// Fashion till features that need server tables not set up yet. Size holds
// need cwr_fsh_hold and markdowns / final sale need cwr_fsh_markdown; until
// those are raised through NOTON the till hides them and asks the server for
// nothing. The server also checks the tables and refuses if they're missing.
export const FASHION_FEATURES = Object.freeze({ holds: false, markdowns: false });
